import { log } from '@hungryroot/o11y';
import { type OrderV2 } from '@hungryroot/rest';
import { analytics } from '../segment';
import { getUtmSessionStorage } from './components/Utm/getUtmSessionStorage';

export type SegmentCompletedRegistrationMethod =
  | 'email'
  | 'facebook'
  | 'apple'
  | 'google';

const APP_DATA = {
  context: {
    app: {
      name: 'Hungryroot Web',
      namespace: 'hungryroot.com',
    },
  },
};

export function funnelAnalytics() {
  const utmData = getUtmSessionStorage();

  const defaultData = {
    ...APP_DATA,
    campaign: utmData,
  };

  return {
    completedRegistration: (
      customer: {
        id: number;
        email: string;
      },
      method: 'email' | 'facebook' | 'apple' | 'google'
    ) => {
      const { id: user_id, email } = customer;

      analytics.track('Completed Registration', {
        ...defaultData,
        email,
        method,
      });

      log('Completed Registration', {
        ...defaultData,
        user_id,
        method,
      });
    },
    checkoutStarted: (customerId: number) => {
      analytics.track('Checkout Started', {
        ...defaultData,
      });

      log('Checkout Started', {
        ...defaultData,
        user_id: customerId,
      });
    },
    orderCompleted: (
      user_id: number,
      order: Pick<
        OrderV2,
        'id' | 'total' | 'shipping_cost' | 'tax' | 'discount' | 'promo_code_id'
      >
    ) => {
      const { id, total, shipping_cost, tax, discount, promo_code_id } = order;

      const orderData = {
        checkout_id: id,
        order_id: id,
        shipping: shipping_cost,
        coupon: promo_code_id,
        currency: 'USD',
        total,
        tax,
        discount,
      };

      analytics.track('Order Completed', {
        ...defaultData,
        ...orderData,
      });

      log('Order Completed', {
        ...defaultData,
        ...orderData,
        user_id,
      });
    },
  };
}
